/*-------------------------------------------
	Quick Links
-------------------------------------------*/

	"use strict";
	var $ = jQuery;
	import { addLargeListener, largeModeQuery } from "../base/page.js";
	import { get as getCookie, set as setCookie } from "../base/cookies.js";
	import "../base/swap.js";

	var $QuickLinks,
	$QuickLinksHandle,
	$QuickLinksClose,
	$MenuControl,
	$MenuTrigger,
	$MenuPanel,
	$MenuLink,
	$CurrentTrigger,
	WindowWidth,
	LockClass;

	function initQuickLinks() {
        $QuickLinks = $(".js-quick-links");

		if ($QuickLinks.length) {
			$QuickLinksHandle = $(".js-audience-toggle");
			$QuickLinksClose = $(".js-quick-links-close");
			$MenuControl = $(".js-quick-links-control");
			$MenuTrigger = $(".js-quick-links-trigger");
			$MenuPanel = $(".js-quick-links-panel");
			$MenuLink = $(".js-quick-links-panel-link");
			LockClass = "fs-page-lock";

			setup();
			bindUI();

			// I believe this is broken on the live site. And what it does
			// seems like non-sense.
			addLargeListener(largeModeChange);
			largeModeChange();
		}
	}

	function setup() {
		$QuickLinks
			.attr("aria-hidden", "true")
			.find("a, button, input").attr("tabindex", "-1");

		$(".js-audience-toggle, .js-quick-links-panel-link").attr({
			"aria-expanded": "false",
			"role": "button"
		});

		// TODO: Use localStorage instead
		var cookie = getCookie("adelphi-quick-links-category");
		if (cookie && /^\d+$/.test(cookie)) {
			$(".js-quick-links-panel-link:eq(" + cookie + ")").swap("activate");
		} else {
			$(".js-quick-links-panel-link:eq(0)").swap("activate");
		}
	}

	function bindUI() {
		$(document).on("click touchstart", onDocumentClick);
		$QuickLinksHandle.on("click", onQuickLinksHandleClick);
		$QuickLinksClose
			.on("keydown", onCloseKeydown)
			.on("click", onQuickLinksSwapDeactivate);
		$QuickLinks
			.on("keydown", onQuickLinksKeydown)
			.on("keyup", onQuickLinksKeyup);
		$MenuTrigger.on("click", onTriggerClick).on("keyup", onTriggerKeyup);
		$MenuPanel.on("keyup", onPanelKeyup);
		$MenuLink.on("activate.swap", onQuickLinksMenuLinkActivate);
	}

	function onDocumentClick(e) {
		if ($("body").hasClass(LockClass)) {
			if (!$(e.target).closest(".js-quick-links").length) {
				$QuickLinksHandle.swap("deactivate");
				onQuickLinksSwapDeactivate();
			}
		}
	}

	function onQuickLinksHandleClick() {
		if ($(this).attr("aria-expanded") == "false") {
			onQuickLinksSwapActivate();
		} else {
			onQuickLinksSwapDeactivate();
		}
	}

	function onQuickLinksSwapActivate() {
		$QuickLinksHandle.attr("aria-expanded", "true");
		$(".js-menu-handle").swap("deactivate");
		$QuickLinks.attr({
			"aria-hidden": "false",
			"tabindex": "0"
		}).one('transitionend', function () {
			$QuickLinks.focus();
		});
		$(".js-quick-links-cat.fs-swap-active").find("a, button, input").removeAttr("tabindex");
		$QuickLinksClose.removeAttr("tabindex");
		if (WindowWidth >= 980) {
			$(".js-quick-links-panel-link").removeAttr("tabindex");
		}
	}

	function onQuickLinksSwapDeactivate() {
		$QuickLinks
			.attr("aria-hidden", "true")
			.removeAttr("tabindex")
			.find("a, button, input").attr("tabindex", "-1");
		$QuickLinksHandle.attr("aria-expanded", "false");

		$QuickLinksClose.attr("tabindex", "-1");
		$(".js-quick-links-panel-link").attr("tabindex", "-1");
		if (WindowWidth < 980) {
			$(".js-header-buttons .js-quick-links-handle").focus();
		} else {
			// $(".js-audience-toggle").focus();
		}
	}

	function onCloseKeydown(e) {
		if (e.keyCode === 9) { // tab
			if (!(e.shiftKey)) {
				$QuickLinks.focus();
			}
		}
	}

	function onQuickLinksKeydown(e) {
		if ($QuickLinks.is(":focus")) {
			if (e.keyCode === 9) { // tab
				if (e.shiftKey) {
					e.preventDefault();
					$QuickLinksClose.focus();
				}
			}
		}
	}

	function onQuickLinksKeyup(e) {

		if (e.keyCode === 27) { // escape
			if (WindowWidth < 980) {
				if (!$(".js-quick-links-panel-link").is(":focus")) {
					$QuickLinksHandle.swap("deactivate");
					onQuickLinksSwapDeactivate();
				}
			} else {
				$QuickLinksHandle.swap("deactivate");
				onQuickLinksSwapDeactivate();
			}
		}
	}

	function onTriggerClick() {
		$CurrentTrigger = $(this);

		if ($CurrentTrigger.attr("aria-expanded") == "false") {
			openPopup();
		} else {
			closePopup();
			$CurrentTrigger.focus();
		}
	}

	function onTriggerKeyup(e) {
		if (e.keyCode === 38) { // up
			e.preventDefault();

			if ($(this).attr("aria-expanded") == "false") {
				$(this).trigger("click");
				$(".js-quick-links-panel-link")
					.last()
					.focus();
			}
		}

		if (e.keyCode === 40) { // down
			e.preventDefault();

			if ($(this).attr("aria-expanded") == "false") {
				$(this).trigger("click");
			}
		}
	}

	function onPanelKeyup(e) {
		var $focusedElement = $(":focus");
		var focusedIndex = $focusedElement.closest(".js-quick-links-panel-item").index();
		var $triggerOpensLink = $(".js-quick-links-panel-link");

		if ([27, 38, 40, 36, 35].indexOf(e.keyCode) > -1) {
			e.preventDefault();
		}

		if (e.keyCode === 27) { // escape
			closePopup();
			$CurrentTrigger.focus();
		}

		if (e.keyCode === 38) { // up
			if (focusedIndex > 0) {
				$triggerOpensLink
					.eq(focusedIndex - 1)
					.focus();
			} else {
				$triggerOpensLink
					.last()
					.focus();
			}
		}

		if (e.keyCode === 40) { // down
			if (!$focusedElement.closest(".js-quick-links-panel-item").is(":last-of-type")) {
				$triggerOpensLink
					.eq(focusedIndex + 1)
					.focus();
			} else {
				$triggerOpensLink
					.first()
					.focus();
			}
		}

		if (e.keyCode === 36) { // home
			$triggerOpensLink
				.first()
				.focus();
		}

		if (e.keyCode === 35) { // end
			$triggerOpensLink
				.last()
				.focus();
		}
	}

	function onQuickLinksMenuLinkActivate() {
		var $activeLink = $(".js-quick-links-panel-link.fs-swap-active");
		var activeString = $activeLink.text();
		var activeIndex = $activeLink.closest(".js-quick-links-panel-item").index();

		// TODO: Use localStorage instead
		setCookie("adelphi-quick-links-category", activeIndex, 30 * 24 * 60 * 60 * 1000);
		$(".js-quick-links-trigger-label").text(activeString);
		$(".js-quick-links-cat").find("a, button, input").attr("tabindex", "-1");
		$(".js-quick-links-cat.fs-swap-active").find("a, button, input").removeAttr("tabindex");
		$(".js-quick-links-panel-link").attr("aria-expanded", "false");
		$activeLink.attr("aria-expanded", "true");

		$CurrentTrigger = $MenuTrigger;
		closePopup();
	}

	function openPopup() {
		$CurrentTrigger.attr("aria-expanded", "true");
		$MenuControl.addClass("open");
		$(".js-quick-links-panel").attr("aria-hidden", "false");
		$(".js-quick-links-panel-link")
			.removeAttr("tabindex")
			.first()
			.focus();
	}

	function closePopup() {
		$CurrentTrigger.attr("aria-expanded", "false");
		$MenuControl.removeClass("open");
		$(".js-quick-links-panel").attr("aria-hidden", "true");
		$(".js-quick-links-panel-link").attr("tabindex", "-1");
	}

	function largeModeChange() {
		if (largeModeQuery.matches) {
			enterLarge();
		} else {
			leaveLarge();
		}
	}

	function enterLarge() {
		$MenuPanel.attr("aria-hidden", "false");
		if ($(".js-quick-links").hasClass("fs-swap-active")) {
			$MenuLink.removeAttr("tabindex");
		}
	}

	function leaveLarge() {
		$MenuLink.attr("tabindex", "-1");
		$MenuPanel.attr("aria-hidden", "true");
	}

	$(initQuickLinks);
